import { InsightGenericData, MonetaryInsight } from '../types';

export enum OrderPunctualityType {
  EARLY = 'earlyOrders',
  ON_TIME = 'onTimeOrders',
  LATE = 'lateOrders',
}

export type PunctualityTotal = {
  avgPreparationTimeSec: number;
  punctuality: number;
} & {
  [key in OrderPunctualityType]: number;
};

export type PunctualityData = {
  label: string | null;
  total: PunctualityTotal;
  split?: PunctualityData[];
};

export type PunctualityInsight = InsightGenericData &
  MonetaryInsight & {
    data: {
      punctuality: PunctualityData | null;
    };
  };
